import { createAction, props } from '@ngrx/store';
import { ICorrelation } from '@app/api/interfaces/correlation.interface';
import { IApiBaseErrorResponse } from '@app/api/interfaces/api-base-error-response.interface';
import { ICorrelationsRequestState } from '@app/main/main-screen/store/data/correlations/correlations.state';

export const loadCorrelations = createAction(
  '[Correlations] Load Correlations',
  props<{ triggerId: string; request: ICorrelationsRequestState }>()
);

export const loadCorrelationsSuccess = createAction(
  '[Correlations] Load Correlations Success',
  props<{
    triggerId: string;
    request: ICorrelationsRequestState;
    correlations: ICorrelation[];
  }>()
);

export const getCorrelation = createAction('[Correlations] Get Correlation', props<{ correlationId: string }>());
export const getCorrelationSuccess = createAction(
  '[Correlations] Get Correlation Success',
  props<{
    correlation: ICorrelation;
  }>()
);

export const correlationFailure = createAction(
  '[Correlations] Correlation Failure',
  props<{
    correlationId: string;
    error: IApiBaseErrorResponse;
  }>()
);

export const correlationsFailure = createAction(
  '[Correlations] Load Failure',
  props<{ error: IApiBaseErrorResponse }>()
);

export const updateCorrelationSuppressed = createAction(
  '[Correlations] Update Correlation Suppressed',
  props<{ correlationId: string; suppressed: boolean }>()
);

export const updateCorrelationSuppressedSuccess = createAction(
  '[Correlations] Update Correlation Suppressed Success',
  props<{ correlation: ICorrelation }>()
);
